import { connect } from 'react-redux';
import { compose, withState } from 'recompose';
import withHandlers from 'recompose/withHandlers';
import GiftCards from '../components/GiftCards';
import { getShop } from '../../../auth/selectors';
import {
  fetchGiftCardSummary,
} from '../actions';

const GiftCardsContainer = compose(
  connect(
    state => ({
      shopId: getShop(state),
    }),
    { fetchGiftCardSummary },
  ),
  withState('giftCard', 'setGiftCard'),
  withHandlers({
    closeModal: props => () => props.setGiftCard(),
  })
)(GiftCards);

export default GiftCardsContainer;
